require('./RAWizardStep.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const OKModal = require('components/commons/OKModal/OKModal');

class RAWizardStep extends React.Component {
    buildModal() {
        const {
            closeModal,
            handleNext,
            modalDescription,
            modalIcon,
            modalOkOnly,
            modalTitle,
        } = this.props;
        const modalHeader = modalIcon ? (
            <div className="ra-wizard-step__modal-icon" />
        ) : null;

        let primaryButtonCallback;
        let primaryButtonText;
        let secondaryButtonCallback;
        let secondaryButtonText;

        if (modalOkOnly) {
            primaryButtonCallback = closeModal;
            primaryButtonText =
                'raSuitabilityTest-firstQuestionModalUnderstood';
        } else {
            primaryButtonCallback = handleNext;
            primaryButtonText = 'raSuitabilityTest-continueModal';
            secondaryButtonCallback = closeModal;
            secondaryButtonText = 'raSuitabilityTest-backModal';
        }

        return (
            <OKModal
                description={modalDescription}
                descriptionAlignment="center"
                footerType="action"
                headerContent={modalHeader}
                headerType="custom"
                isOpen={true}
                shouldCloseOnOverlayClick={false}
                onCloseCallback={closeModal}
                title={modalTitle}
                titleAlignment="center"
                onPrimaryButtonClick={primaryButtonCallback}
                onSecondaryButtonClick={secondaryButtonCallback}
                primaryButtonText={primaryButtonText}
                secondaryButtonText={secondaryButtonText}
            />
        );
    }

    buildTooltip() {
        if (!this.props.showInfoTooltip) {
            return null;
        }
        const target = (
            <div className="ra-wizard-step__tooltip">
                <div className="ra-wizard-step__tooltip-icon" />
            </div>
        );
        return (
            <OKTooltip
                target={target}
                content={this.props.tooltip}
                offset={[0, -15]}
            />
        );
    }

    render() {
        const modal = this.props.showModal ? this.buildModal() : null;
        const tooltip = this.props.tooltip ? this.buildTooltip() : null;
        return (
            <div>
                <div className="ra-wizard-step__subtitle">
                    {this.props.stepSubtitle}
                </div>
                {this.props.children}
                {modal}
                {tooltip}
            </div>
        );
    }
}

RAWizardStep.defaultProps = {
    isCompleted: false,
    shouldDisplayModal: false,
    showModal: false,
    showNextButtonIcon: true,
    showInfoTooltip: true,
};

RAWizardStep.propTypes = {
    stepSubtitle: PropTypes.string,
    children: PropTypes.any,
    closeModal: PropTypes.func,
    handleNext: PropTypes.func,
    identifier: PropTypes.string,
    isCompleted: PropTypes.bool,
    modalDescription: PropTypes.string,
    modalIcon: PropTypes.bool,
    modalOkOnly: PropTypes.bool,
    modalTitle: PropTypes.string,
    nextButtonLabel: PropTypes.string,
    shouldDisplayModal: PropTypes.bool,
    showModal: PropTypes.bool,
    showNextButtonIcon: PropTypes.bool,
    tooltip: PropTypes.string,
    showInfoTooltip: PropTypes.bool,
};

module.exports = RAWizardStep;
